import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button, message, Modal, Upload } from "antd";
import { stationApi } from "@api/newApi";
import sApi from "@api/station";
import { Graph, Shape } from "@antv/x6";
import { Transform } from "@antv/x6-plugin-transform";
import { PlusSquareOutlined, MinusSquareOutlined } from "@ant-design/icons";
import DeviceProcess from "../../../components/deviceProcess";
import "./index.scss";

const { UPLOADER } = window.globalConfig;

Shape.HTML.register({
  shape: "equipment-shape",
  width: 80,
  height: 30,
  effect: ["data"],
  html(cell) {
    const div = document.createElement("div");
    div.className = "device-item-box";
    div.inertHTML = "";
    return div;
  },
});

const Pages = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [checkedIds, setCheckedIds] = useState([]);
  const [bgImgStyle, setBgImgStyle] = useState({
    width: 545,
    height: 785,
  });
  const [isShowPreviewModal, setIsShowPreviewModal] = useState(false);
  const [graphObj, setGraphObj] = useState();
  const [previewProcessData, setPreviewProcessData] = useState({});
  const [loading1, setLoading1] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const [canvasBg, setCanvasBg] = useState("");
  const [deviceList, setDeviceList] = useState([]);

  useEffect(() => {
    initCanvas();
    return () => {
      graphObj && graphObj.destroy();
      setGraphObj(null);
    };
  }, []);

  const initCanvas = () => {
    setTimeout(() => {
      const graph = new Graph({
        container: document.getElementById("topologyCanvas"),
        width: bgImgStyle.width,
        height: bgImgStyle.height,
      });
      graph.use(
        new Transform({
          resizing: {
            enabled: true,
            grid: 15,
            minWidth: 1,
            minHeight: 1,
            orthogonal: false,
            restrict: false,
            preserveAspectRatio: false,
          },
        })
      );
      // 监听 button-remove 的点击事件
      graph.on("node:removed", ({ node }) => {
        const { data, shape } = node.store.data;
        if (shape == "equipment-shape") {
          setCheckedIds((prevIds) =>
            prevIds.filter((item) => item !== data.deviceId)
          );
        }
      });
      setGraphObj(graph);
      findUnitFlow(graph);
      getDevice();
    }, 0);
  };

  const getDevice = () => {
    sApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeviceList(res.data);
    });
  };

  const findUnitFlow = (graphObj) => {
    stationApi.findDeviceFlow(stationId).then((res) => {
      if (res.status !== "0") return;
      const { canvasHeight, canvasWidth, deviceDTOList } = res.data;
      if (canvasWidth && canvasHeight) {
        setBgImgStyle({ width: canvasWidth, height: canvasHeight });
        graphObj.resize(canvasWidth, canvasHeight);
      }
      setCanvasBg(res.data.canvasBg);
      if (deviceDTOList && deviceDTOList.length > 0) {
        const ids = [];
        deviceDTOList.forEach((item) => {
          ids.push(item.id);
          const graphNode = generateNode({
            ...item,
            x: item.posX,
            y: item.posY,
          });
          graphObj.addNode(graphNode);
        });
        setCheckedIds(ids);
      }
    });
  };

  // 预览按钮
  const previewBtn = () => {
    const params = handleData();
    setPreviewProcessData(params);
    setIsShowPreviewModal(true);
  };

  const handleData = () => {
    const datas = graphObj.toJSON().cells;
    const deviceDTOList = [];
    datas.forEach((item) => {
      if (item.shape == "equipment-shape") {
        deviceDTOList.push({
          posX: item.position.x,
          posY: item.position.y,
          width: item.size.width,
          height: item.size.height,
          deviceDiyId: item.data.deviceId,
        });
      }
    });
    const params = {
      stationId,
      name: "厂站设备流程",
      canvasWidth: bgImgStyle.width,
      canvasHeight: bgImgStyle.height,
      canvasBg,
      deviceDTOList,
    };
    return params;
  };

  // 完成按钮
  const saveBtn = () => {
    const data = handleData();
    setLoading1(true);
    stationApi
      .updateDeviceFlow(data)
      .then((res) => {
        setLoading1(false);
        if (res.status !== "0") return;
        message.success("保存成功");
      })
      .catch(() => {
        setLoading1(false);
      });
  };

  const onDragStartFn = (event) => {
    event.dataTransfer.dropEffect = "move";
  };

  const onDragOverFn = (event) => {
    event.preventDefault(); // 确保浏览器允许拖拽
    event.dataTransfer.dropEffect = "move"; // 设置具体的拖拽效果
  };

  const onDragEndFn = (event, data) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    const topologyCanvas = document.getElementById("topologyCanvas");
    const offsetLeft = topologyCanvas.getBoundingClientRect().left;
    const offsetTop = topologyCanvas.getBoundingClientRect().top;
    let x = event.clientX - offsetLeft;
    let y = event.clientY - offsetTop;
    if (data.hide) return;
    if (x < 0 || y < 0) return message.error("请拖拽到画布上");
    const params = {
      ...data,
      x,
      y,
      width: 150,
      height: 150,
    };
    const nodeOptions = generateNode(params);
    graphObj.addNode(nodeOptions);
    setCheckedIds(() => {
      return [...checkedIds, data.deviceId];
    });
  };

  const generateNode = (data) => {
    const { x, y, width, height } = data;
    const nodes = {
      shape: "equipment-shape",
      x,
      y,
      width,
      height,
      data,
      tools: ["button-remove"],
    };
    return nodes;
  };

  // 背景图样式改变事件
  const changeImgStyle = (e, type) => {
    let obj = { ...bgImgStyle };
    obj[type] = e.target.value * 1;
    setBgImgStyle({
      ...obj,
    });
  };

  // 修改背景底图样式
  const bgImgStyleSure = () => {
    graphObj.resize(bgImgStyle.width, bgImgStyle.height);
  };

  const uploadProps = {
    accept: "image/png",
    action: UPLOADER,
    listType: "picture",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("你只能上传jpg或png图片格式");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("图片必需小于5M");
      }
      return isJpgOrPng && isLt5M;
    },
    onChange: (info) => {
      if (info.file.status === "uploading") {
        setImgLoading(true);
      }
      if (info.file.status === "done") {
        const res = info.file.response;
        setImgLoading(false);
        if (res.status == "0") {
          setCanvasBg(res.data.url);
        }
      }
    },
  };

  const changeExpand = (obj) => {
    obj.pand = !obj.pand;
    setDeviceList(() => {
      return [...deviceList];
    });
  };

  const RenderTree = ({ list = [] }) => {
    return list.map((item) => {
      return (
        <div className="tree-item" key={item.id}>
          <div
            className={classnames({
              "tree-title": true,
              disabledExist:
                checkedIds.includes(item.deviceId) || item.child.length > 0,
              "tree-title-hasChild": item.child.length > 0,
            })}
            draggable={
              !checkedIds.includes(item.deviceId) && item.child.length == 0
            }
            onDragStart={onDragStartFn}
            onDragOver={onDragOverFn}
            onDragEnd={(e) => onDragEndFn(e, item)}
          >
            {item.child && item.child.length > 0 && (
              <div className="tree-icon" onClick={() => changeExpand(item)}>
                {item.pand ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
              </div>
            )}
            <div className="tree-name">{item.itemName}</div>
          </div>
          <div
            className="sub-item"
            style={{
              paddingLeft: 10,
              height: item.pand ? "auto" : 0,
              transition: "all .3s ease",
            }}
          >
            {item.child && item.child.length > 0 && (
              <RenderTree list={item.child} />
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="equipmentProcess" id="processSet-step2-box">
      <div className="top-box">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Upload {...uploadProps}>
            <Button type="default" loading={imgLoading}>
              设置背景底图
            </Button>
          </Upload>
          {
            <div className="ipt-box">
              背景图样式设置： 宽：
              <input
                value={bgImgStyle.width}
                onChange={(e) => changeImgStyle(e, "width")}
                type="number"
              />
              高：
              <input
                value={bgImgStyle.height}
                onChange={(e) => changeImgStyle(e, "height")}
                type="number"
              />
              <Button size="small" onClick={bgImgStyleSure}>
                确 定
              </Button>
            </div>
          }
        </div>
        <div className="btn-area">
          <Button
            type="primary"
            onClick={previewBtn}
            style={{ marginRight: 10 }}
          >
            预览
          </Button>
          <Button loading={loading1} type="primary" onClick={saveBtn}>
            完成
          </Button>
        </div>
      </div>
      <div className="con-box">
        <div className="process-area">
          <div className="tit">工艺环节</div>
          <div className="process-box">
            <div className="tree-box">
              <RenderTree list={deviceList} />
            </div>
          </div>
        </div>
        <div className="canvas-box">
          <div
            onDragOver={(e) => e.preventDefault()}
            id="topologyCanvas"
            style={{ backgroundImage: `url(${canvasBg})` }}
          ></div>
        </div>
      </div>
      {isShowPreviewModal && (
        <Modal
          title="预览"
          open={isShowPreviewModal}
          width={bgImgStyle.width}
          getContainer={() => document.getElementById("processSet-step2-box")}
          onCancel={() => {
            setIsShowPreviewModal(false);
            setPreviewProcessData({});
          }}
          footer={false}
        >
          <div style={{ height: bgImgStyle.height, background: "#101621" }}>
            <DeviceProcess data={previewProcessData} />
          </div>
        </Modal>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
